/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerCancelMutationResponse,
  TelegramTransactionsUserControllerCancelPathParams,
  TelegramTransactionsUserControllerCancel401,
} from '../../types/TelegramTransactionsUserControllerCancel.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramTransactionsUserCancel } from '../../methods/telegramTransactionsUserCancel.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramTransactionsUserCancelMutationKey = () =>
  [{ url: '/api/user/telegram/transactions/cancel/:id' }] as const;

export type TelegramTransactionsUserCancelMutationKey = ReturnType<typeof telegramTransactionsUserCancelMutationKey>;

/**
 * {@link /api/user/telegram/transactions/cancel/:id}
 */
export function useTelegramTransactionsUserCancel<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramTransactionsUserControllerCancelMutationResponse,
      ResponseErrorConfig<TelegramTransactionsUserControllerCancel401>,
      { id: TelegramTransactionsUserControllerCancelPathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramTransactionsUserCancelMutationKey();

  return useMutation<
    TelegramTransactionsUserControllerCancelMutationResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerCancel401>,
    { id: TelegramTransactionsUserControllerCancelPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return telegramTransactionsUserCancel(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
